module.exports = __webpack_public_path__ + "static/stava_full-481e158b9f62b4577578d2eca4513de1.jpg";